<template>
  <div class="logo">
    <router-link :to="{path: '/' }">
     <!-- <img style="width: 220px;" src="@/assets/images/logo.png" alt="logo" />-->
      <h1 v-if="showTitle">{{ projectName }}</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
